// extracted by mini-css-extract-plugin
export default {"clients":"clients_clients__jYcHG","brands":"clients_brands__MgOur"};